<template>
<div>
    <v-form @submit.prevent="agregar">
        <v-container lighten-5>

            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-card>
                        <v-card-actions>
                            <div class="flex-grow-1"></div>
                            <v-btn color="primary darken-1" dark @click="agregar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <span class="headline green--text">DATOS DEL USUARIO</span>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-card>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        Datos del usuario
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field type="password" v-model="formUser.password_hash" label="password" outlined required />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field type="password" v-model="formUser.repassword" label="re password" outlined required />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </v-container>
    </v-form>
</div>
</template>

<script>
export default {
    data() {
        return {
            user: this.$cookies.get("user"),
            url: "sistema/personas/",
            token: this.$cookies.get("token"),
            formUser: {
                //email: "",
                password_hash: "",
                repassword: ""
            },
            rules: {
                password: [
                    v => !!v || "requiredo",
                    v =>
                    (v && v.length > 2) || "La contraseña debe tener almenos 4 digitos"
                ],
                repassword: [
                    v => !!v || "requiredo",
                    v =>
                    (v && v.length > 2) || "La contraseña debe tener almenos 4 digitos"
                ],
            },

        }
    },

    methods: {
        async agregar() {
            if (this.formUser.password_hash && this.formUser.repassword) {
                 await this.$apiService.update("sistema/user/update/" + this.$cookies.get('user').id + "/", this.formUser).then(data => data);
            }
        },
    }
}
</script>
